import { useEffect, useState } from 'react';
import { useLocation, useSearchParams } from "react-router-dom";
import makeStyles from '@mui/styles/makeStyles';

import styles from 'assets/jss/Report/ReportStyle';
import LogBook from 'components/Report/Logbook/LogBook';
import Review from 'components/Report/Report';
import Tab from 'components/Report/Tab';
import MainHeader from 'components/Header/MainHeader';
import { usePatientInfo } from 'hooks/usePatient';
import ReportCatchHandler from 'components/Report/Report/report-error';
const useStyles = makeStyles(styles);

export default function Report() {
    const classes = useStyles();
    const [activeTab, setActiveApp] = useState(1);

    const [searchParams, setSearchParams] = useSearchParams();
    const patientId = searchParams.get('patientId');
    console.log(patientId);

    const { isError } = usePatientInfo(patientId);

    const logbookClicked = () => setActiveApp(2);
    const reviewClicked = () => setActiveApp(1);

    const MainHeaderProps = {
        showShareModal: true,
        showBackBtn: true,
        showUserAccorion: true,
        patientId,
    };

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, []);

    if (!patientId?.length || isError) {
        return <ReportCatchHandler />;
    }

    return (
        <div>
            <MainHeader {...MainHeaderProps} />
            <Tab activeTab={activeTab} logbookClicked={logbookClicked} reviewClicked={reviewClicked} />
            <div className={classes.wrapper}>
                {activeTab === 1 ? (
                    <Review patientId={patientId} />
                ) : (
                    <LogBook patientId={patientId} />
                )}
            </div>
        </div>
    );
}
